import React from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import amolImg from "../assets/images/amol.jpg";
import harshImg from "../assets/images/harshwardhan.jpg";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./ProductDevelopment.css";
import dashboardImg from "./Dashboard.png";
import {
  FaLaptopCode,
  FaBolt,
  FaCloud,
  FaShieldAlt,
  FaClock,
  FaRocket,
  FaHeadset,
  FaTools,
  FaChartLine,
  FaArrowRight,
  FaArrowDown,
  FaJava,
  FaNodeJs,
  FaAws,
  FaDocker,
  FaGithub,
  FaServer
} from "react-icons/fa";

import {
  SiReact,
  SiSpringboot,
  SiDotnet,
  SiPython,
  SiFastapi,
  SiMysql,
  SiMongodb
} from "react-icons/si";

export default function ProductDevelopment() {
  const navigate = useNavigate();

  const handleStartProject = () => {
    navigate("/", {
      state: {
        scrollTo: "contact",
      },
    });
  };

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}

      <section className="pd-hero">

        <div className="hero-content">

          <span className="hero-tag">
            PRODUCT DEVELOPMENT
          </span>

          <h1>
            We Build
            <br />
            <span>Scalable Software</span>
            <br />
            Products
          </h1>

          <p>
            E-Forum Software Solutions partners with startups and
            enterprises to design, build and scale digital products.
            We combine innovation, engineering excellence and agile
            methodologies to deliver secure, cloud-ready software that
            accelerates business growth.
          </p>

          <div className="hero-list">
            <div>✓ Custom Software Development</div>
            <div>✓ Enterprise Applications</div>
            <div>✓ Cloud Native Solutions</div>
            <div>✓ AI Powered Products</div>
          </div>

          <div className="hero-buttons">

            <button
              className="btn-primary"
              onClick={handleStartProject}
            >
              Start Your Project
            </button>

            <Link
              to="experts"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="btn-secondary">
                Talk To Our Experts
              </button>
            </Link>

          </div>

        </div>

        <div className="hero-image">

          <img
            src={dashboardImg}
            alt="Product Development"
          />

        </div>

      </section>
{/* ================= EXPERTS ================= */}

<section id="experts" className="experts-section">

  <div className="section-heading">



    <h2>Talk To Our Experts</h2>

    <p>
      Connect with our experienced technology leaders to discuss your
      product idea, software requirements and digital transformation
      journey.
    </p>

  </div>

  <div className="experts-grid">

    <div className="expert-card">

      <img
        src={amolImg}
        alt="Amol Gomkale"
      />

      <h3>Amol Gomkale</h3>

      <h4>Director, E-Forum Software Solutions</h4>

      <p>
        Enterprise Software Development, Cloud Solutions,
        Product Engineering and Technology Consulting.
      </p>

      <div className="expert-links">

        <a href="mailto:amol.gomkale@eforumsystems.com">
          📧 Email
        </a>

        <a
          href="https://www.linkedin.com/in/amol-gomkale-7276504"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>

      </div>

    </div>

    <div className="expert-card">

      <img
        src={harshImg}
        alt="Harshwardhan Damle"
      />

      <h3>Harshwardhan Damle</h3>

      <h4>Founder, Opslytic</h4>

      <p>
        Product Strategy, AI Solutions,
        Data Analytics and Digital Transformation.
      </p>

      <div className="expert-links">

        <a href="mailto:harshwardhan.damle@outlook.com">
          📧 Email
        </a>

        <a
          href="https://www.linkedin.com/in/harshwardhan"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>

      </div>

    </div>

  </div>

</section>
{/* ================= ABOUT ================= */}

<section className="pd-about">

  <div className="about-image">

    <img
      src={dashboardImg}
      alt="Product Development"
    />

  </div>

  <div className="about-content">

    <span className="section-tag">
      PRODUCT ENGINEERING
    </span>

    <h2>
      Transforming Ideas Into
      <span> Successful Digital Products</span>
    </h2>

    <p>
      At E-Forum Software Solutions, we help businesses transform ideas
      into scalable digital products. From concept validation and UI/UX
      design to development, deployment and long-term support, our team
      delivers secure and future-ready software solutions.
    </p>

    <p>
      Our agile development methodology ensures faster releases,
      continuous innovation and exceptional user experiences while
      maintaining enterprise-grade quality and security.
    </p>

 <div className="about-grid">

  <div className="about-box">

    <h3>
      <FaLaptopCode className="about-icon" />
      Custom Software
    </h3>

    <p>
      Tailor-made software solutions designed around your business.
    </p>

  </div>

  <div className="about-box">

    <h3>
      <FaBolt className="about-icon" />
      Agile Delivery
    </h3>

    <p>
      Faster product releases with continuous improvement.
    </p>

  </div>

  <div className="about-box">

    <h3>
      <FaCloud className="about-icon" />
      Cloud Native
    </h3>

    <p>
      Modern applications built for AWS, Azure and Google Cloud.
    </p>

  </div>

  <div className="about-box">

    <h3>
      <FaShieldAlt className="about-icon" />
      Enterprise Security
    </h3>

    <p>
      Secure architecture with authentication, encryption and compliance best practices.
    </p>

  </div>

</div>
  </div>

</section>
{/* ================= DEVELOPMENT PROCESS ================= */}
<section className="pd-process">

  <div className="section-heading">
    <span>OUR PROCESS</span>
    <h2>How We Build Successful Products</h2>

    <p>
      Our agile product engineering process ensures transparency,
      speed and exceptional software quality.
    </p>
  </div>

  <div className="process-row">

    <div className="process-card">
      <div className="process-number">01</div>
      <h3>Discovery</h3>
      <p>Understanding business goals, user needs and project scope.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-card">
      <div className="process-number">02</div>
      <h3>Planning</h3>
      <p>Architecture, timelines and technology roadmap.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-card">
      <div className="process-number">03</div>
      <h3>UI / UX Design</h3>
      <p>Creating intuitive and engaging user experiences.</p>
    </div>

  </div>

  <div className="process-down">
      ↓
  </div>

  <div className="process-row reverse">

    <div className="process-card">
      <div className="process-number">06</div>
      <h3>Deployment & Support</h3>
      <p>Production deployment and continuous monitoring.</p>
    </div>

    <div className="process-arrow">←</div>

    <div className="process-card">
      <div className="process-number">05</div>
      <h3>Testing</h3>
      <p>Functional, security and performance testing.</p>
    </div>

    <div className="process-arrow">←</div>

    <div className="process-card">
      <div className="process-number">04</div>
      <h3>Development</h3>
      <p>Agile software development using modern technologies.</p>
    </div>

  </div>

</section>



{/* ================= TECHNOLOGIES ================= */}


<div className="tech-grid">

  <div className="tech-card">
    <SiReact className="tech-icon react"/>
    <h3>React</h3>
    <p>Frontend Library</p>
  </div>

  <div className="tech-card">
    <FaJava className="tech-icon java"/>
    <h3>Java</h3>
    <p>Enterprise Development</p>
  </div>

  <div className="tech-card">
    <SiSpringboot className="tech-icon spring"/>
    <h3>Spring Boot</h3>
    <p>Backend Framework</p>
  </div>

  <div className="tech-card">
    <SiDotnet className="tech-icon dotnet"/>
    <h3>.NET</h3>
    <p>Microsoft Platform</p>
  </div>

  <div className="tech-card">
    <FaNodeJs className="tech-icon node"/>
    <h3>Node.js</h3>
    <p>JavaScript Runtime</p>
  </div>

  <div className="tech-card">
    <SiPython className="tech-icon python"/>
    <h3>Python</h3>
    <p>AI & Automation</p>
  </div>

  <div className="tech-card">
 <SiFastapi className="tech-icon fastapi" />
    <h3>FastAPI</h3>
    <p>High Performance APIs</p>
  </div>

  <div className="tech-card">
   <FaAws className="tech-icon aws"/>
    <h3>AWS</h3>
    <p>Cloud Infrastructure</p>
  </div>

  <div className="tech-card">
  <FaCloud className="tech-icon azure" />
    <h3>Azure</h3>
    <p>Microsoft Cloud</p>
  </div>

  <div className="tech-card">
<FaDocker className="tech-icon docker"/>
    <h3>Docker</h3>
    <p>Containerization</p>
  </div>

  <div className="tech-card">
    <SiMongodb className="tech-icon mongo"/>
    <h3>MongoDB</h3>
    <p>NoSQL Database</p>
  </div>

  <div className="tech-card">
    <SiMysql className="tech-icon mysql"/>
    <h3>MySQL</h3>
    <p>Relational Database</p>
  </div>

  <div className="tech-card">
<FaGithub className="tech-icon github"/>
    <h3>GitHub</h3>
    <p>Version Control</p>
  </div>

</div>

{/* ================= WHY CHOOSE US ================= */}

<section className="pd-why">

  <div className="section-heading">

    <span>WHY CHOOSE E-FORUM</span>

    <h2>Why Businesses Trust Us</h2>

    <p>
      We combine technology expertise, agile methodologies and customer-focused
      delivery to build digital products that create real business value.
    </p>

  </div>

  <div className="why-grid">

    <div className="why-card">
      <h3>✔ Experienced Engineering Team</h3>
      <p>
        Skilled professionals delivering enterprise-grade software solutions.
      </p>
    </div>

    <div className="why-card">
      <h3>✔ Agile Development</h3>
      <p>
        Faster releases with continuous feedback and transparent communication.
      </p>
    </div>

    <div className="why-card">
      <h3>✔ Scalable Architecture</h3>
      <p>
        Applications designed for performance, reliability and future growth.
      </p>
    </div>

    <div className="why-card">
      <h3>✔ End-to-End Development</h3>
      <p>
        From idea validation to deployment and long-term maintenance.
      </p>
    </div>

    <div className="why-card">
      <h3>✔ Quality & Security</h3>
      <p>
        Secure coding practices, testing and industry-standard development.
      </p>
    </div>

    <div className="why-card">
      <h3>✔ Long-Term Partnership</h3>
      <p>
        Dedicated support, enhancements and continuous product improvement.
      </p>
    </div>

  </div>

</section>
{/* ================= FINAL CTA ================= */}

<section className="pd-cta">

  <div className="cta-content">

    <span>LET'S BUILD TOGETHER</span>

    <h2>
      Ready to Build Your Next Digital Product?
    </h2>

    <p>
      Whether you're a startup with a new idea or an enterprise looking
      to modernize existing software, our engineering team is ready to
      help you transform your vision into reality.
    </p>

    <div className="cta-buttons">

      <button
        className="cta-primary"
        onClick={handleStartProject}
      >
        Start Your Project
      </button>

      <Link
        to="experts"
        smooth={true}
        duration={700}
        offset={-80}
      >
        <button className="cta-secondary">
          Talk To Our Experts
        </button>
      </Link>

    </div>

  </div>

</section>

      <Footer />
    </>
  );
}
{/* ================= WHY CHOOSE US ================= */}

<section className="pm-why">

  <div className="section-heading">

    <span>WHY E-FORUM</span>

    <h2>Why Choose Our Maintenance Services?</h2>

    <p>
      We don't just fix issues—we proactively improve, secure and optimize
      your software so your business can operate without interruptions.
    </p>

  </div>

  <div className="why-grid">

    <div className="why-card">

      <FaClock className="why-icon" />

      <h3>24×7 Monitoring</h3>

      <p>
        Continuous monitoring keeps your applications available,
        responsive and secure around the clock.
      </p>

    </div>

    <div className="why-card">

      <FaShieldAlt className="why-icon" />

      <h3>Enterprise Security</h3>

      <p>
        Security patches, compliance updates and vulnerability
        management to protect your systems.
      </p>

    </div>

    <div className="why-card">

      <FaRocket className="why-icon" />

      <h3>Performance Boost</h3>

      <p>
        Optimize databases, APIs and application performance
        for faster user experiences.
      </p>

    </div>

    <div className="why-card">

      <FaHeadset className="why-icon" />

      <h3>Dedicated Support</h3>

      <p>
        A dedicated maintenance team ensures quick response
        and faster issue resolution.
      </p>

    </div>

    <div className="why-card">

      <FaTools className="why-icon" />

      <h3>Preventive Maintenance</h3>

      <p>
        Regular audits and preventive actions reduce
        unexpected production failures.
      </p>

    </div>

    <div className="why-card">

      <FaChartLine className="why-icon" />

      <h3>Continuous Improvement</h3>

      <p>
        We continuously enhance software based on business
        goals, analytics and user feedback.
      </p>

    </div>

  </div>

</section>
